import { Navigate, useLocation } from "react-router-dom";

export default function Signup() {
  const { search } = useLocation();
  const ref = new URLSearchParams(search).get("ref");
  const dest = ref
    ? `/welcome?auth=signup&ref=${encodeURIComponent(ref)}`
    : "/welcome?auth=signup";
  return <Navigate to={dest} replace />;
}
